import React, { useState, useEffect, useRef } from 'react';
import solarsystem from "../assets/rootimg/kundli2.jpg";
import men from "../assets/rootimg/male3.png";
import women from "../assets/rootimg/women3.png";
import relationships from "../assets/rootimg/relationship.png";
import couple from "../assets/rootimg/couple.png";
import { IoPersonSharp } from "react-icons/io5";
import { RiMoneyRupeeCircleFill } from "react-icons/ri";
import Footer from '../home/Footer';
import compatibility from "../assets/rootimg/compatibility.png";
import rings from "../assets/rootimg/kundlicomp.png";
import { IoMdArrowRoundForward } from 'react-icons/io';
import Queryform from './Queryform';
import { useNavigate } from 'react-router';
import Navbar from '../home/Navbar';
import axios from 'axios';
import { API_END_POINT } from './Utils/Constant';
import BlogRecommendations from './AstroBlog/BlogRecommendations';

const KundliMatching = () => {
  const navigate = useNavigate();
  const [formDataBoy, setFormDataBoy] = useState({
    name: "",
    day: "1",
    month: "Jan",
    year: "2000",
    hour: "15",
    minute: "22",
    second: "10",
    birthPlace: "",
    latitude: "",
    longitude: "",
  });
  const [formDataGirl, setFormDataGirl] = useState({
    name: "",
    day: "1",
    month: "Jan",
    year: "2000",
    hour: "15",
    minute: "22",
    second: "10",
    birthPlace: "",
    latitude: "",
    longitude: "",
  });

  const [suggestionsBoy, setSuggestionsBoy] = useState([]);
  const [selectedIndexBoy, setSelectedIndexBoy] = useState(null);
  const [suggestionsGirl, setSuggestionsGirl] = useState([]);
  const [selectedIndexGirl, setSelectedIndexGirl] = useState(null);
  const birthPlaceInputBoy = useRef(null);
  const birthPlaceInputGirl = useRef(null);
  const [loading, setLoading] = useState(false);

  const handlePlaceSearchBoy = async (e) => {
    const query = e.target.value;
    if (query.length < 3) {
      setSuggestions([]);
      return;
    }

    try {
      const response = await axios.get(`${API_END_POINT}data/places/suggestions?city=${query}`);
      if (response.data) {
        setSuggestionsBoy(response.data);
      }
    } catch (error) {
      console.error('Error fetching place suggestions:', error);
      setSuggestionsBoy([]);
    }
  };

  // Handle suggestion selection
  const handleSuggestionSelectBoy = (suggestion) => {
    setFormDataBoy((prevData) => ({
      ...prevData,
      birthPlace: suggestion.place_name,
      latitude: suggestion.latitude,
      longitude: suggestion.longitude,
    }));
    setSuggestionsBoy([]);
    setSelectedIndexBoy(null);
  };
  const handlePlaceSearchGirl = async (e) => {
    const query = e.target.value;
    if (query.length < 3) {
      setSuggestionsGirl([]);
      return;
    }

    try {
      const response = await axios.get(`${API_END_POINT}data/places/suggestions?city=${query}`);
      if (response.data) {
        setSuggestionsGirl(response.data);
      }
    } catch (error) {
      console.error('Error fetching place suggestions:', error);
      setSuggestionsGirl([]);
    }
  };

  // Handle suggestion selection
  const handleSuggestionSelectGirl = (suggestion) => {
    setFormDataGirl((prevData) => ({
      ...prevData,
      birthPlace: suggestion.place_name,
      latitude: suggestion.latitude,
      longitude: suggestion.longitude,
    }));
    setSuggestionsGirl([]);
    setSelectedIndexGirl(null);
  };
  // Handle keydown events for navigating suggestions
  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      setSelectedIndex((prevIndex) => (prevIndex === null ? 0 : Math.min(suggestions.length - 1, prevIndex + 1)));
    } else if (e.key === "ArrowUp") {
      setSelectedIndex((prevIndex) => (prevIndex === null ? 0 : Math.max(0, prevIndex - 1)));
    } else if (e.key === "Enter" && selectedIndex !== null) {
      handleSuggestionSelect(suggestions[selectedIndex]);
    }
  };

  const handleSubmit1 = (e) => {
    navigate('/login');
  }
  const compatibilityhandler = (e) => {
    e.preventDefault();
    navigate('/compatibility');
  }
  const kundlihandler = (e) => {
    e.preventDefault();
    navigate('/new-kundli');
  }

  // Updates boy's form data
  const handleChangeBoy = (e) => {
    const { name, value } = e.target;
    setFormDataBoy((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Updates girl's form data
  const handleChangeGirl = (e) => {
    const { name, value } = e.target;
    setFormDataGirl((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const fetchMatchingData = async () => {
    console.log('Form data before submitting:', formDataBoy, formDataGirl);
    setLoading(true);

    try {
      const requestBody = {
        boy: {
          name: formDataBoy.name,
          day: formDataBoy.day,
          month: formDataBoy.month,
          year: formDataBoy.year,
          hour: formDataBoy.hour,
          minute: formDataBoy.minute,
          latitude: formDataBoy.latitude,
          longitude: formDataBoy.longitude,
        },
        girl: {
          name: formDataGirl.name,
          day: formDataGirl.day,
          month: formDataGirl.month,
          year: formDataGirl.year,
          hour: formDataGirl.hour,
          minute: formDataGirl.minute,
          latitude: formDataGirl.latitude,
          longitude: formDataGirl.longitude,
        },
      };

      const [planetsResponse, ascendantResponse] = await Promise.all([
        axios.post(`${API_END_POINT}kundli-matching/north-match-planetsdetails`, requestBody),
        axios.post(`${API_END_POINT}kundli-matching/north-match-ascendant`, requestBody),
      ]);

      const kundliMatchingData = {
        planetsDetails: planetsResponse.data.data, // Note: .data.data due to backend structure
        matchAscendant: ascendantResponse.data.data,
      };

      navigate('/kundli-matching-result', { state: { ...kundliMatchingData } });
    } catch (error) {
      console.error('Error fetching matching data:', error);
      if (error.response) {
        console.log('Error response data:', error.response.data);
      }
    } finally {
      setLoading(false);
    }
  };


  // Handles form submission
  const handleSubmitKundli = (e) => {
    e.preventDefault();
    // console.log("Form Submitted:", formDataBoy, formDataGirl);
    // Fetch matching data
    fetchMatchingData();
  };


  return (
    <>
      <section className='bg-gradient-to-r from-white to-success/40 text-gray-900 min-h-screen'>
        <div className=''>
          <Navbar />
        </div>

        {/* Header Section */}
        <div className='text-center  mt-10'>
          <div className="flex flex-col sm:flex-row justify-center items-center text-center sm:text-left">
            <img src={relationships} alt="bull.png" className="w-6 h-6 sm:w-8 sm:h-8 mr-2 mb-2 object-cover" />
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold font-serif text-secondary mb-2">
              KUNDLI MATCHING
            </h1>
          </div>
          <p className='text-xl font-serif text-secondary font-semibold'>
            Find your perfect match based on your astrological chart and preferences.
          </p>
          <div className='flex text-center mt-3 justify-center items-center'>
            <hr className='border-gray-500 h-2 sm:w-32 w-96 md:w-48 mt-2 mr-1' />
            <img
              src={solarsystem}
              alt='kundli.png'
              className='w-10 h-10 rounded-full object-cover shadow-2xl shadow-gray-800'
            />
            <hr className='border-gray-500 h-2 sm:w-32 w-96 md:w-48 mt-2 ml-1' />
          </div>
        </div>

        {/* Information Section */}
        <div className='flex flex-col md:flex-row text-justify items-center mx-4 md:mx-32 mt-5'>

          <div className='flex flex-col max-w-4xl md:w-3/4'>
            <h1 className='font-bold text-secondary text-lg md:text-2xl'>
              Free Matchmaking - Kundli-Gun Milan to Explore Marriage Compatibility
            </h1>
            <p className='mt-1 text-sm md:text-base'>
              Kundli Milan, or Kundali matching, is an important tradition to consider when planning for marriage. Also known as Gun Milan or Horoscope matching, it is the first step taken by families to assess the compatibility of the couple. The process involves comparing the Kundlis of the bride and groom to ensure they are well-suited for each other. This practice has been an integral part of Indian culture for thousands of years and continues to play a significant role in marriage decisions today.
            </p>
            <p className='mt-1 text-sm md:text-base'>
              If you're planning to get married and are looking for horoscope matching with someone you're interested in, AstroTellers can help. The Kundali Milan online software on AstroTellers has been created by top astrologers to assist with your matchmaking needs. This free Kundli Milan service offers valuable insights, including the number of Gun matches between the girl and boy, their compatibility, and what their future together might look like if they marry. The online Gun Milan tool saves you time and eliminates the hassle of searching for an astrologer in person. And if you have any questions or doubts about the free Kundali Milan provided by AstroTellers, you can always connect with the astrologers on the platform for clarification.
            </p>
          </div>
          <div className='mt-4 md:mt-0 md:w-1/4'>
            <img
              src={couple}
              alt='couple.png'
              className='w-full h-64 md:h-72 object-contain'
            />
          </div>
        </div>
        {/* Form Section */}
        <div className='text-center'>
          <h2 className='text-2xl mt-4 mb-4 font-serif text-gray-900 font-bold'>Enter Your Partner's Details</h2>
        </div>
        <div className='flex flex-col md:flex-row gap-4 md:mx-28'>
          {/* Boy's Form */}
          <form className='bg-blue-300 shadow-xl rounded px-8 pt-6 pb-8 mb-4 flex-1'>
            <div className='flex flex-row items-center justify-center bg-blue-500 rounded-full py-1 mt-2'>
              <h2 className='text-xl text-white font-semibold'>Boy's Detail</h2>

            </div>

            {/* Input Fields */}
            <label className='block text-gray-700 text-sm font-bold mt-3 mb-2'>
              Name*
              <input
                type='text'
                name='name'
                value={formDataBoy.name}
                placeholder='Full Name'
                onChange={handleChangeBoy}
                required
                className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-1 ring-blue-600'
              />
            </label>

            {/* Date and Time Fields */}
            <div className='grid grid-cols-3 gap-4 mb-4'>
              <label className='block text-gray-700 text-sm font-bold'>
                Day*
                <select
                  name='day'
                  value={formDataBoy.day}
                  onChange={handleChangeBoy}
                  required
                  className='block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 focus:ring-1 ring-blue-600 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none'
                >
                  {Array.from({ length: 31 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
                </select>
              </label>

              <label className='block text-gray-700 text-sm font-bold'>
                Month*
                <select
                  name='month'
                  value={formDataBoy.month}
                  onChange={handleChangeBoy}
                  required
                  className='block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 focus:ring-1 ring-blue-600 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none'
                >
                  {["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"].map((month, i) => (
                    <option key={i} value={month}>
                      {month}
                    </option>
                  ))}
                </select>
              </label>

              <label className='block text-gray-700 text-sm font-bold'>
                Year*
                <input
                  type='number'
                  name='year'
                  value={formDataBoy.year}
                  onChange={handleChangeBoy}
                  required
                  className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:ring-1 ring-blue-600 leading-tight focus:outline-none'
                />
              </label>
            </div>

            {/* Time Fields */}
            <div className='grid grid-cols-3 gap-4 mb-4'>
              <label className='block text-gray-700 text-sm font-bold'>
                Hour*
                <input
                  type='number'
                  name='hour'
                  value={formDataBoy.hour}
                  onChange={handleChangeBoy}
                  required
                  className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:ring-1 ring-blue-600 leading-tight focus:outline-none'
                />
              </label>

              <label className='block text-gray-700 text-sm font-bold'>
                Minute*
                <input
                  type='number'
                  name='minute'
                  value={formDataBoy.minute}
                  onChange={handleChangeBoy}
                  required
                  className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:ring-1 ring-blue-600 leading-tight focus:outline-none'
                />
              </label>

              <label className='block text-gray-700 text-sm font-bold'>
                Second
                <input
                  type='number'
                  name='second'
                  value={formDataBoy.second}
                  onChange={handleChangeBoy}
                  className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:ring-1 ring-blue-600 leading-tight focus:outline-none'
                />
              </label>
            </div>

            {/* Birth Place Input with Suggestions */}
            <label className="block text-gray-700 text-sm font-bold mb-4">
              Birth Place*
              <input
                type="text"
                name="birthPlace"
                ref={birthPlaceInputBoy}
                placeholder="Enter Your Birth Place"
                value={formDataBoy.birthPlace}
                onChange={handleChangeBoy}
                onInput={handlePlaceSearchBoy}
                onKeyDown={handleKeyDown}
                required
                className="w-full border border-secondary rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-secondary"
              />
            </label>

            {/* Display place suggestions */}
            {suggestionsBoy.length > 0 && (
              <div className="bg-white border border-gray-300 rounded-md mt-2 max-h-60 overflow-y-auto">
                {suggestionsBoy.map((suggestion, index) => (
                  <div
                    key={index}
                    onClick={() => handleSuggestionSelectBoy(suggestion)}
                    className={`cursor-pointer p-2 hover:bg-gray-200 ${selectedIndexBoy === index ? "bg-gray-300" : ""}`} // Highlight the selected suggestion
                  >
                    {suggestion.place_name} {/* Assuming 'place_name' is the name of the place */}
                  </div>
                ))}
              </div>
            )}

          </form>

          {/* Girl's Form */}
          <form className='bg-pink-300 shadow-xl rounded px-8 pt-6 pb-8 mb-4 flex-1'>
            <div className='flex flex-row items-center justify-center bg-pink-500 rounded-full py-1 mt-2'>
              <h2 className='text-xl text-white font-semibold'>Girl's Detail</h2>

            </div>

            {/* Input Fields */}
            <label className='block text-gray-700 text-sm font-bold mt-3 mb-2'>
              Name*
              <input
                type='text'
                name='name'
                value={formDataGirl.name}
                placeholder='Full Name'
                onChange={handleChangeGirl}
                required
                className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:ring-1 ring-pink-600 leading-tight focus:outline-none focus:shadow-outline'
              />
            </label>

            {/* Date and Time Fields */}
            <div className='grid grid-cols-3 gap-4 mb-4'>
              <label className='block text-gray-700 text-sm font-bold'>
                Day*
                <select
                  name='day'
                  value={formDataGirl.day}
                  onChange={handleChangeGirl}
                  required
                  className='block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 focus:ring-1 ring-pink-600 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none'
                >
                  {Array.from({ length: 31 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
                </select>
              </label>

              <label className='block text-gray-700 text-sm font-bold'>
                Month*
                <select
                  name='month'
                  value={formDataGirl.month}
                  onChange={handleChangeGirl}
                  required
                  className='block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 focus:ring-1 ring-pink-600 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none'
                >
                  {["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"].map((month, i) => (
                    <option key={i} value={month}>
                      {month}
                    </option>
                  ))}
                </select>
              </label>

              <label className='block text-gray-700 text-sm font-bold'>
                Year*
                <input
                  type='number'
                  name='year'
                  value={formDataGirl.year}
                  onChange={handleChangeGirl}
                  required
                  className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:ring-1 ring-pink-600 leading-tight focus:outline-none focus:shadow-outline'
                />
              </label>
            </div>

            {/* Time Fields */}
            <div className='grid grid-cols-3 gap-4 mb-4'>
              <label className='block text-gray-700 text-sm font-bold'>
                Hour*
                <input
                  type='number'
                  name='hour'
                  value={formDataGirl.hour}
                  onChange={handleChangeGirl}
                  required
                  className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:ring-1 ring-pink-600 leading-tight focus:outline-none focus:shadow-outline'
                />
              </label>

              <label className='block text-gray-700 text-sm font-bold'>
                Minute*
                <input
                  type='number'
                  name='minute'
                  value={formDataGirl.minute}
                  onChange={handleChangeGirl}
                  required
                  className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:ring-1 ring-pink-600 leading-tight focus:outline-none focus:shadow-outline'
                />
              </label>

              <label className='block text-gray-700 text-sm font-bold'>
                Second
                <input
                  type='number'
                  name='second'
                  value={formDataGirl.second}
                  onChange={handleChangeGirl}
                  className='shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:ring-1 ring-pink-600 leading-tight focus:outline-none focus:shadow-outline'
                />
              </label>
            </div>

            {/* Birth Place */}
            <label className="block text-gray-700 text-sm font-bold mb-4">
              Birth Place*
              <input
                type="text"
                name="birthPlace"
                ref={birthPlaceInputGirl}
                placeholder="Enter Your Birth Place"
                value={formDataGirl.birthPlace}
                onChange={handleChangeGirl}
                onInput={handlePlaceSearchGirl}
                onKeyDown={handleKeyDown}
                required
                className="w-full border border-secondary rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-secondary"
              />
            </label>

            {/* Display place suggestions */}
            {suggestionsGirl.length > 0 && (
              <div className="bg-white border border-gray-300 rounded-md mt-2 max-h-60 overflow-y-auto">
                {suggestionsGirl.map((suggestion, index) => (
                  <div
                    key={index}
                    onClick={() => handleSuggestionSelectGirl(suggestion)}
                    className={`cursor-pointer p-2 hover:bg-gray-200 ${selectedIndexGirl === index ? "bg-gray-300" : ""}`} // Highlight the selected suggestion
                  >
                    {suggestion.place_name} {/* Assuming 'place_name' is the name of the place */}
                  </div>
                ))}
              </div>
            )}
          </form>
        </div>

        {/* Submit Button */}
        <div className='flex justify-center'>

          <button
            type='submit'
            onClick={handleSubmitKundli}
            className='lg:w-2/3 lg:ml-32 lg:mr-32 md:w-3/4 bg-gray-900 transition duration-300 hover:bg-success text-white font-bold py-2 px-6 rounded-3xl focus:outline-none focus:shadow-outline'
            disabled={loading}
          >
            {loading ? "Generating..." : "Match Kundli"}
          </button>
        </div>
        {/* Paid Add div */}
        <div className="bg-success py-6 mt-5 flex justify-center items-center">
          <div className="bg-gradient-to-r from-white to-gray-100/80 flex flex-col justify-center items-center w-full sm:w-3/4 lg:w-2/3 h-auto sm:h-2/3 shadow-2xl rounded-3xl p-4 sm:p-6 lg:p-8 text-center">
            <h2 className="text-base sm:text-lg md:text-xl font-bold mt-3 sm:mt-4">
              Get Your Personalized Kundli Matching Report in PDF Format
            </h2>
            <p className="text-sm sm:text-base mt-2 text-gray-700">
              Unlock detailed insights into your compatibility with a comprehensive PDF report. Perfect for sharing with family and friends!
            </p>
            <button
              onClick={() => navigate('/comming-soon')}
              className="bg-black text-white font-semibold py-2 px-10 sm:px-12 md:px-14 rounded-full hover:bg-gray-900 ring-1 ring-white focus:outline-none focus:ring-2 focus:ring-success focus:ring-opacity-50 flex items-center justify-center mt-4"
            >
              <RiMoneyRupeeCircleFill className="h-4 w-4 mr-2" />
              Buy PDF Report
            </button>
          </div>
        </div>

        <div className='justify-center '>
          <h2 className="text-xl sm:text-2xl font-serif mt-10 font-bold text-center text-secondary">
            Kundli Matching: Kundli Gun Milan (Horoscope Compatibility Matching)
          </h2>
          <h3 className="text-lg sm:text-xl text-center text-gray-500">
            A Friend or a Foe?
          </h3>

          <div className="px-4 sm:px-8 md:px-16 lg:px-32 mt-6 text-justify text-sm sm:text-base">
            <p>
              Every individual carries their own unique energy, shaped by the influence of specific planets and zodiac signs.
              Each person's energy field is distinct, and naturally, it will differ from that of others. In simpler terms,
              your energies may not always align with someone else's, and this is what makes you and each person you encounter truly unique.
            </p>

            <p className="mt-2">
              This is where Kundli matching, also known as Kundli Milan, horoscope matching, or Kundali Gun Milan, comes into play.
              As an ancient science, Kundli matching helps us determine whether the energies we carry align or complement those of our
              partner or future spouse. In essence, Kundli Milan provides valuable insight into the compatibility between two individuals,
              as compatibility is one of the key factors that sustain a lasting relationship.
            </p>

            <p className="mt-2">
              Horoscope matching, or Kundli matching in Vedic astrology, takes into account both the planetary positions at the time of
              birth and their current positions to assess the compatibility between two individuals. This process is crucial for determining
              whether the planetary alignments are favorable or unfavorable for the relationship.
            </p>

            <h2 className="font-bold mt-4">
              Kundli Milan - A Friend Or A Foe?
            </h2>
            <p className="mt-2">
              Many couples, especially those hoping for a love marriage, view Kundli matching as an obstacle to their relationship.
              They fear the questions that may arise if their Kundlis don't align. However, this perception is based on misconceptions.
              Kundli matching is a tool that can offer valuable insights, not a barrier to love.
            </p>

            <h2 className="font-bold mt-4">
              What happens during Kundli Milan?
            </h2>
            <p className="mt-2">
              Horoscope matching, a practice deeply rooted in Vedic astrology, is a significant step for many when considering marriage.
              This process is known as AshtaKoot Milan, where "Ashta" means 8, and "Koot" refers to categories or parameters.
              Each category is assigned points, adding up to a total of 36 Gunas. The higher the number of matching Gunas, the stronger
              the compatibility between the couple.
            </p>

            <h2 className="font-bold mt-4">
              The Eight Key Parameters of AshtaKoot Milan
            </h2>

            {/* Parameter Sections */}
            {[
              { title: "Varna", description: "This classification divides people into four categories based on their characteristics: Brahmin, Kshatriya, Vaishya, and Shudra." },
              { title: "Vashya", description: "Vashya denotes dominance or control in Vedic astrology. It classifies a person into five types: Human, Wild Animal, Small Animal, Waterborne Animals, and Insects." },
              { title: "Tara", description: "Tara is related to the birth star compatibility of both partners, influencing their emotional and spiritual connection." },
              { title: "Yoni", description: "This parameter focuses on sexual compatibility between the couple, examining how their energies interact physically and emotionally." },
              { title: "Rasyadhipati", description: "Rasyadhipati defines the Lord of the Zodiac for each person and the compatibility of these planetary rulers." },
              { title: "Gana", description: "In astrology, there are three Ganas: Dev (Godly), Manav (Human), and Rakshasa (Demonic), assessing social and mental compatibility." },
              { title: "Rashi", description: "This category evaluates the Moon’s position in the horoscopes to determine emotional connection between partners." },
              { title: "Nadi", description: "Nadi Koot focuses on health and fertility compatibility, considering Vata (air), Pitta (bile), and Kapha (phlegm) doshas." }
            ].map((item, index) => (
              <div key={index} className="mt-4">
                <div className="flex items-center">
                  <IoMdArrowRoundForward className="text-primary mr-2" />
                  <h2 className="font-bold">{item.title}</h2>
                </div>
                <p className="ml-6">{item.description}</p>
              </div>
            ))}

            <p className="mt-4">
              It is generally believed that at least 18 gunas must align for a marriage to be successful and harmonious. The more gunas that match,
              the better the prospects for the couple’s happiness.
            </p>

            <p className="mt-4">
              In addition to other factors, Kundli matching helps determine if the union will result in Nadi Dosha, which can affect the couple's ability to have children.
              If Madhya Nadi Dosha is present, the couple may struggle with fertility.
            </p>

            <p className="mt-4">
              Therefore, it is always advisable to choose Gun Milan or Kundli Milan, as it allows you to identify potential issues in your relationship beforehand
              and provides solutions to address them.
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-stretch gap-4 md:gap-6 px-4 md:px-12 lg:px-52">
            {/* Card 1 */}
            <div className="bg-white w-full md:w-1/2 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto mt-5 p-4 rounded-lg">
              <div className="flex flex-col sm:flex-row items-center">
                <img
                  src={rings}
                  alt="kundli.png"
                  className="w-24 h-20 sm:w-32 sm:h-24 m-2 sm:m-4 border rounded-xl border-white bg-white"
                />
                <div className="text-center sm:text-left">
                  <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">Get Your Kundli</h3>
                  <p className="text-sm sm:text-base text-justify mb-4">
                    Kundli, an astrological birth chart, offers insights into an individual's life, personality, and future.
                    With online Kundli services, you can generate your birth chart, analyze planetary positions, and receive
                    personalized predictions and remedies from the comfort of home.
                  </p>
                  <button
                    onClick={kundlihandler}
                    className="bg-secondary w-full sm:w-fit h-auto p-3 rounded-md hover:bg-success text-white"
                  >
                    Free Kundli
                  </button>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="bg-white w-full md:w-1/2 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto mt-5 p-4 rounded-lg">
              <div className="flex flex-col sm:flex-row items-center">
                <img
                  src={compatibility}
                  alt="compatibility.png"
                  className="w-24 h-20 sm:w-32 sm:h-24 m-2 sm:m-4 border rounded-xl border-white bg-white"
                />
                <div className="text-center sm:text-left">
                  <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">Compatibility</h3>
                  <p className="text-sm sm:text-base text-justify mb-4">
                    Compatibility helps you understand how well your astrological traits align with those of another person.
                    By comparing your birth chart with others, you can find someone who shares your characteristics.
                  </p>
                  <button
                    onClick={compatibilityhandler}
                    className="bg-secondary w-full sm:w-fit h-auto p-3 rounded-md hover:bg-success text-white"
                  >
                    Check Compatibility
                  </button>
                </div>
              </div>
            </div>
          </div>
          <BlogRecommendations />
          <div>
            <Queryform />
          </div>
        </div>
        <div className='mt-10'>
          <Footer />
        </div>
      </section>
    </>
  );
};

export default KundliMatching;
